<template>
  <DetailTemplate
    :customClass="'property-detail property-property-detail detail-page'"
    v-if="getPermission('property:view')"
  >
    <template v-slot:header-title>
      <v-skeleton-loader
        class="custom-skeleton"
        v-if="pageLoading"
        width="400"
        height="28"
        type="text"
      >
      </v-skeleton-loader>
      <div class="d-flex">
        <h1 class="form-title custom-nowrap-ellipsis text-capitalize mr-2 mt-3">
          {{ getPageTitle }}
        </h1>
        <v-chip
          label
          color="chip-custom-blue"
          outlined
          class="text-white p-3 mt-2"
          style="font-size: 21px !important; font-weight: 700"
          >{{ propertyArr.barcode }}</v-chip
        >
        <span>
          <v-chip
            outlined
            color="blue"
            label
            class="ml-2"
            v-if="
              propertyArr &&
              propertyArr.customer &&
              propertyArr.customer.company_type &&
              propertyArr.customer.company_type == 'company'
            "
          >
            <span class="font-size-16 font-weight-500"> Company </span>
          </v-chip>
          <v-chip
            outlined
            color="red"
            label
            class="ml-2"
            v-if="
              propertyArr &&
              propertyArr.customer &&
              propertyArr.customer.company_type &&
              propertyArr.customer.company_type == 'personal'
            "
          >
            <span class="font-size-16 font-weight-500"> Individual </span>
          </v-chip>
          <Status :status="getStatus" class="ml-2 p-3"></Status>
        </span>
      </div>
      <!--  <h1 class="form-title custom-nowrap-ellipsis text-capitalize">
        {{ getPageTitle }}
      </h1> -->
    </template>
    <template v-slot:header-action>
      <v-skeleton-loader
        class="custom-skeleton d-inline-block mr-2"
        v-if="pageLoading"
        type="button"
        height="28"
      >
      </v-skeleton-loader>
      <template v-else>
        <v-menu
          v-if="createTransactions.length > 0"
          :close-on-click="true"
          bottom
          content-class="custom-menu-list"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              depressed
              class="mx-2 custom-bold-button white--text"
              v-bind="attrs"
              v-on="on"
              color="cyan"
            >
              Create... <v-icon right>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <template v-for="(item, index) in createTransactions">
              <v-list-item
                :key="index"
                link
                v-on:click="createTransaction(propertyArr, item.action)"
              >
                <v-list-item-icon class="margin-auto-zero mr-3 my-2">
                  <span class="svg-icon svg-icon-lg svg-v-list-icon">
                    <!--begin::Svg Icon-->
                    <inline-svg
                      :src="
                        $assetURL('media/custom-svg/' + item.action + '.svg')
                      "
                    />
                    <!--end::Svg Icon-->
                  </span>
                </v-list-item-icon>
                <v-list-item-title class="font-size-14 mt-2 mb-2">{{
                  item.title
                }}</v-list-item-title>
              </v-list-item>
            </template>
          </v-list>
        </v-menu>
      </template>
      <template v-if="getPermission('property:update')">
        <v-skeleton-loader
          class="custom-skeleton d-inline-block mr-2"
          v-if="pageLoading"
          type="button"
          height="28"
        >
        </v-skeleton-loader>
        <v-btn
          depressed
          v-else
          class="mx-2 custom-bold-button white--text"
          color="cyan"
          :to="
            getDefaultRoute('property.update', {
              param: { id: property },
              query: { customer: customer },
            })
          "
        >
          <v-icon small left>mdi-pencil</v-icon>
          Edit
        </v-btn>
      </template>
      <v-btn
        depressed
        class="mx-2 custom-grey-border custom-bold-button"
        v-on:click="goBack"
      >
        <v-icon small left>mdi-keyboard-backspace</v-icon>
        Back
      </v-btn>
    </template>
    <template v-slot:body>
      <v-tabs
        v-model="propertyTab"
        background-color="transparent"
        color="cyan"
        class="custom-tab-transparent"
      >
        <template v-for="(tab, index) in tabs">
          <v-tab
            class="font-size-16 font-weight-600 px-8"
            :key="index"
            :href="'#' + tab.key"
            :disabled="tab.disabled"
          >
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <!--begin::Svg Icon-->
              <!-- <inline-svg
                :src="$assetURL('media/custom-svg/' + tab.key + '.svg')"
              /> -->
              <v-icon v-if="tab.icon" class="mr-2" size="20">
                {{ tab.icon }}
              </v-icon>
              <!--end::Svg Icon-->
            </span>
            {{ tab.title }}
          </v-tab>
        </template>
      </v-tabs>
      <perfect-scrollbar
        :options="{ suppressScrollX: true }"
        class="scroll newscroll"
        style="height: calc(100vh - 150px)"
      >
        <v-tabs-items v-model="propertyTab">
          <v-tab-item v-if="getPermission('property:view')" :value="'property'">
            <v-row class="white-background">
              <v-col cols="6">
                <v-container class="pt-0">
                  <v-card-text class="pt-4 pb-0 font-size-16">
                    <v-skeleton-loader
                      class="custom-skeleton height-30px"
                      v-if="pageLoading"
                      type="text@11"
                    >
                    </v-skeleton-loader>
                    <template v-else>
                      <table class="width-100">
                        <tr>
                          <th
                            class="font-size-18 font-weight-500 text-capitalize"
                            width="150px"
                          >
                            Site Location #
                          </th>
                          <td class="font-size-18 text-capitalize">
                            <Barcode :barcode="getBarcode"></Barcode>
                          </td>
                        </tr>
                        <tr>
                          <th
                            class="font-size-18 font-weight-500 text-capitalize"
                          >
                            Site Location Name
                          </th>
                          <td class="font-size-18 text-capitalize">
                            <template v-if="propertyArr?.property_name">
                              {{ propertyArr?.property_name }}
                            </template>
                            <em v-else class="text-muted">No Name</em>
                          </td>
                        </tr>
                        <tr>
                          <th
                            class="font-size-18 font-weight-500 text-capitalize"
                          >
                            Unit No
                          </th>
                          <td class="font-size-18 text-capitalize">
                            <template v-if="propertyArr.unit_no">
                              {{ propertyArr.unit_no }}
                            </template>
                            <em v-else class="text-muted">No Unit No</em>
                          </td>
                        </tr>
                        <tr>
                          <th
                            class="font-size-18 font-weight-500 text-capitalize"
                          >
                            Address Line 1
                          </th>
                          <td class="font-size-18 text-capitalize">
                            <template v-if="propertyArr.street_1">
                              {{ propertyArr.street_1 }}
                            </template>
                            <em v-else class="text-muted">No Address Line 1</em>
                          </td>
                        </tr>
                        <tr>
                          <th
                            class="font-size-18 font-weight-500 text-capitalize"
                          >
                            Address Line 2
                          </th>
                          <td class="font-size-18 text-capitalize">
                            <template v-if="propertyArr.street_2">
                              {{ propertyArr.street_2 }}
                            </template>
                            <em v-else class="text-muted">
                              No Address Line 2</em
                            >
                          </td>
                        </tr>
                        <tr>
                          <th
                            class="font-size-18 font-weight-500 text-capitalize"
                          >
                            Postal Code
                          </th>
                          <td class="font-size-18 text-capitalize">
                            <template
                              v-if="
                                propertyArr.zip_code &&
                                propertyArr.zip_code != '000000'
                              "
                            >
                              {{ propertyArr.zip_code }}
                            </template>
                            <em v-else class="text-muted">No Postal Code</em>
                          </td>
                        </tr>

                        <tr
                          v-if="lodash.isEmpty(propertyArr.country) === false"
                        >
                          <th
                            class="font-size-18 font-weight-500 text-capitalize"
                          >
                            Country
                          </th>
                          <td class="font-size-18 text-capitalize">
                            {{ propertyArr.country }}
                          </td>
                        </tr>

                        <tr v-if="false">
                          <th
                            class="font-size-18 font-weight-500 text-capitalize"
                          >
                            Latitude
                          </th>
                          <td class="font-size-18 text-capitalize">
                            {{ propertyArr.latitude }}
                          </td>
                        </tr>
                        <tr v-if="false">
                          <th
                            class="font-size-18 font-weight-500 text-capitalize"
                          >
                            Longitude
                          </th>
                          <td class="font-size-18 text-capitalize">
                            {{ propertyArr.longitude }}
                          </td>
                        </tr>

                        <tr>
                          <th
                            class="font-size-18 font-weight-500 text-capitalize"
                          >
                            Zone Territory
                          </th>
                          <td class="font-size-18 text-capitalize">
                            <template
                              v-if="
                                propertyArr.zone_territory &&
                                propertyArr.zone_territory != '000000'
                              "
                            >
                              <v-chip
                                v-if="propertyArr?.zone_color"
                                small
                                :color="propertyArr?.zone_color"
                                class="ml-1 mt-n1"
                                label
                                outlined
                                text-color=""
                              >
                                {{ propertyArr.zone_territory }}
                              </v-chip>
                            </template>
                            <em v-else class="text-muted">No zone territory</em>
                          </td>
                        </tr>

                        <tr>
                          <th
                            valign="top"
                            class="font-size-18 font-weight-500 text-capitalize"
                          >
                            Remarks
                          </th>
                          <td class="font-size-18 text-capitalize">
                            <template v-if="propertyArr.remarks">
                              {{ propertyArr.remarks }}
                            </template>
                            <em v-else class="text-muted"> No Remarks</em>
                          </td>
                        </tr>
                      </table>
                      <div class="mt-4">
                        <h3
                          class="pb-4 font-size-20 font-weight-700 color-custom-blue custom-border-bottom"
                        >
                          Contact Person
                          <v-chip
                            label
                            small
                            class="mx-4 my-2"
                            color="green"
                            outlined
                            v-if="propertyArr.is_tenant"
                            >Tenant</v-chip
                          >
                        </h3>
                        <table
                          v-if="propertyArr.contact_person"
                          width="100%"
                          v-on:click="routeToCustomer(propertyArr.customer.id)"
                        >
                          <tr>
                            <th
                              valign="middle"
                              class="font-size-18 font-weight-500 text-capitalize"
                              width="150px"
                            >
                              Customer #
                            </th>
                            <td
                              valign="middle"
                              class="font-size-18 text-capitalize"
                            >
                              <Barcode
                                v-if="propertyArr.customer.barcode"
                                :barcode="propertyArr.customer.barcode"
                              ></Barcode>
                              <em v-else class="text-muted">
                                No Display Name
                              </em>
                            </td>
                          </tr>
                          <tr>
                            <th
                              valign="middle"
                              class="font-size-18 font-weight-500 text-capitalize"
                            >
                              Company Name
                            </th>
                            <td
                              valign="middle"
                              class="font-size-18 text-capitalize"
                            >
                              <template
                                v-if="propertyArr.customer.company_name"
                              >
                                {{ propertyArr.customer.company_name }}
                              </template>
                              <em v-else class="text-muted">
                                No Company Name</em
                              >
                            </td>
                          </tr>
                          <tr>
                            <th
                              valign="middle"
                              class="font-size-18 font-weight-500 text-capitalize"
                            >
                              Display Name
                            </th>
                            <td
                              valign="middle"
                              class="font-size-18 text-capitalize"
                            >
                              <template
                                v-if="propertyArr.contact_person.display_name"
                              >
                                {{ propertyArr.contact_person.display_name }}
                              </template>
                              <em v-else class="text-muted">
                                No Display Name</em
                              >
                            </td>
                          </tr>
                          <tr>
                            <th
                              valign="middle"
                              class="font-size-18 font-weight-500 text-capitalize"
                            >
                              Email
                            </th>
                            <td
                              valign="middle"
                              class="font-size-18 text-lowercase"
                            >
                              <template
                                v-if="propertyArr.contact_person.primary_email"
                              >
                                {{ propertyArr.contact_person.primary_email }}
                              </template>
                              <em v-else class="text-muted ml-2"> No Email</em>
                            </td>
                          </tr>
                          <tr>
                            <th
                              valign="middle"
                              class="font-size-18 font-weight-500 text-capitalize"
                            >
                              Phone
                            </th>
                            <td
                              valign="middle"
                              class="font-size-18 text-capitalize"
                            >
                              <template
                                v-if="propertyArr.contact_person.primary_phone"
                              >
                                {{ propertyArr.contact_person.primary_phone }}
                              </template>
                              <em v-else class="text-muted ml-2"> No Phone</em>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </template>
                  </v-card-text>
                </v-container>
              </v-col>
              <v-col cols="6">
                <GmapMap ref="mapRef" :center="mapCenter" :zoom="11">
                  <GmapMarker :position="mapCenter" />
                </GmapMap>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item value="property-history">
            <!-- <ListingTable :columnCount="3" :dataLoading="historyLoading">
              <template v-slot:thead>
                <thead>
                  <tr>
                    <th class="simple-table-th">#</th>
                    <th class="simple-table-th">Contact Person</th>
                    <th class="simple-table-th">Date Time</th>
                  </tr>
                </thead>
              </template>
              <template v-slot:tbody>
                <tbody class="custom-border-bottom">
                  <template v-if="history.length">
                    <tr v-for="(row, index) in history" :key="index">
                      <td class="simple-table-td">{{ index + 1 }}.</td>
                      <td class="simple-table-td">
                        <v-chip
                          label
                          small
                          class="my-2"
                          color="green"
                          outlined
                          v-if="row.tenant"
                          >Tenant</v-chip
                        >
                        <div class="property-listing-customer">
                          <p class="m-0 custom-nowrap-ellipsis">
                            <b>Display Name: </b>
                            {{ row.display_name }}
                          </p>
                          <p class="m-0 custom-nowrap-ellipsis">
                            <b>Email: </b>
                            {{ row.primary_email }}
                          </p>
                          <p class="m-0 custom-nowrap-ellipsis">
                            <b>Phone: </b>
                            {{ row.primary_phone }}
                          </p>
                        </div>
                      </td>
                      <td class="simple-table-td">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              class="mx-2 my-1 custom-grey-border"
                              color="blue-grey darken-1"
                              text-color="white"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-avatar left>
                                <v-icon>mdi-clock-outline</v-icon>
                              </v-avatar>
                              <p class="m-0 custom-nowrap-ellipsis">
                                {{ formatDate(row.added_at) }}
                                {{ formatDateStartTime(row.added_at) }}
                              </p>
                            </v-chip>
                          </template>
                          <p class="m-0 custom-nowrap-ellipsis">
                            {{ row.created_at }}
                          </p>
                        </v-tooltip>
                      </td>
                    </tr>
                  </template>
                  <tr v-else-if="!historyLoading">
                    <td :colspan="3" class="py-4">
                      <p
                        class="m-0 row-not-found text-center font-weight-500 font-size-16"
                      >
                        <img
                          :src="$assetURL('media/error/empty.png')"
                          class="row-not-found-image"
                        />
                        Uhh... There are no history at the moment.
                      </p>
                    </td>
                  </tr>
                </tbody>
              </template>
            </ListingTable> -->

            <InternalHistoryDetail
              type="property"
              :type_id="propertyArr?.id"
            ></InternalHistoryDetail>
          </v-tab-item>
          <v-tab-item v-if="getPermission('job:view')" :value="'job'">
            <VisitInternalAll
              :detail="propertyArr"
              type="property"
              :property-id="propertyArr?.id"
            ></VisitInternalAll>
            <!--   <Tickets :detail="propertyArr" type="property"></Tickets> -->
          </v-tab-item>
          <v-tab-item
            v-if="getPermission('equipment:view')"
            :value="'equipment'"
          >
            <Equipment
              :property-id="propertyArr.id"
              :detail="propertyArr"
              type="property"
            ></Equipment>
            <!--   <Tickets :detail="propertyArr" type="property"></Tickets> -->
          </v-tab-item>
          <v-tab-item
            v-if="false && getPermission('quotation:view')"
            :value="'quotation'"
          >
            <Quotations :detail="propertyArr" type="property"></Quotations>
          </v-tab-item>
          <v-tab-item v-if="getPermission('invoice:view')" :value="'invoice'">
            <Invoices :detail="propertyArr" type="property"></Invoices>
          </v-tab-item>
          <v-tab-item v-if="getPermission('product:view')" :value="'product'">
            <Products :detail="propertyArr" type="property"></Products>
          </v-tab-item>
          <v-tab-item :value="'warranty'">
            <Warranty :detail="propertyArr" type="property"></Warranty>
          </v-tab-item>
          <v-tab-item :value="'history'">
            <v-card flat class="custom-grey-border remove-border-radius mt-4">
              <v-card-title class="headline grey lighten-4">
                <v-row>
                  <v-col md="5" class="py-0 my-auto">
                    <h3
                      class="font-weight-700 custom-headline color-custom-blue"
                      style="margin: 3.5px 0px"
                    >
                      category
                    </h3>
                  </v-col>
                  <template>
                    <v-col
                      md="7"
                      class="text-left py-0"
                      style="margin-left: -40px"
                    >
                      <v-btn
                        depressed
                        small
                        class="mx-4"
                        v-on:click="AddCatgory"
                      >
                        <span class="font-size-16 font-weight-600">Add</span>
                      </v-btn>
                      <v-btn
                        depressed
                        small
                        class="text-white"
                        color="cyan"
                        :disabled="pageLoading"
                        :loading="pageLoading"
                        v-on:click="updateOrcreate"
                      >
                        <span class="font-size-16 font-weight-600">Update</span>
                      </v-btn>
                    </v-col>
                  </template>
                </v-row>
              </v-card-title>
              <v-card-text class="p-6 font-size-16">
                <v-row>
                  <v-col md="6" class="pb-4">
                    <table class="width-100 mt-4">
                      <tbody>
                        <tr
                          v-for="(type, index) in category.categoryList"
                          :key="index"
                          class="custom-grey-border remove-border-radius"
                        >
                          <td>
                            <v-text-field
                              v-model="type.name"
                              dense
                              filled
                              label="Category"
                              solo
                              flat
                              class="px-4 py-2"
                              hide-details
                              color="cyan"
                            ></v-text-field>
                            <table class="width-100 mt-4">
                              <tbody>
                                <tr
                                  v-for="(sabcate, Cindex) in type.subcategory"
                                  :key="Cindex"
                                >
                                  <td>
                                    <v-text-field
                                      v-model="sabcate.name"
                                      dense
                                      filled
                                      label="Sub Category"
                                      solo
                                      flat
                                      class="ml-1"
                                      hide-details
                                      color="cyan"
                                    ></v-text-field>
                                  </td>
                                  <td width="50" valign="top">
                                    <template>
                                      <v-btn
                                        depressed
                                        fab
                                        dark
                                        x-small
                                        color="cyan"
                                        class="mr-3 custom-disabled btn-border-radius"
                                        v-on:click="AddSubCate(index)"
                                      >
                                        <v-icon>mdi-plus</v-icon>
                                      </v-btn>
                                    </template>
                                  </td>
                                  <td width="50" valign="top">
                                    <template>
                                      <v-btn
                                        depressed
                                        fab
                                        dark
                                        x-small
                                        color="red"
                                        class="mr-3 custom-disabled btn-border-radius"
                                        v-on:click="
                                          deleteSubcategory(index, Cindex)
                                        "
                                      >
                                        <v-icon
                                          :disabled="
                                            type.subcategory.length == 1
                                          "
                                          >mdi-minus</v-icon
                                        >
                                      </v-btn>
                                    </template>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                          <td width="50" valign="top">
                            <v-icon
                              v-on:click="deletecategory(index)"
                              size="32"
                              class="mt-1"
                              :disabled="category.categoryList.length == 1"
                              color="red"
                            >
                              mdi-delete
                            </v-icon>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </perfect-scrollbar>
    </template>
    <template v-slot:footer>
      <template v-if="transaction_contact_person_dialog">
        <CustomerPersonDialog
          :customerPersonDialog="transaction_contact_person_dialog"
          :customer="transaction_customer"
          v-on:closeDialog="closeDialog"
          v-on:resetAll="resetAll"
          v-on:selectCustomerPerson="selectCustomerPerson"
        ></CustomerPersonDialog>
      </template>
    </template>
  </DetailTemplate>
</template>

<script>
import InternalHistoryDetail from "@/view/pages/partials/Detail/Internal-History-Detail.vue";
import CommonMixin from "@/core/plugins/common-mixin";
import ValidationMixin from "@/core/plugins/validation-mixin";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import PropertyMixin from "@/core/plugins/property-mixin";
import Barcode from "@/view/pages/partials/Barcode.vue";
import DetailTemplate from "@/view/pages/partials/Detail-Template.vue";
import CustomerPersonDialog from "@/view/pages/partials/Select-Customer-Person.vue";
import Equipment from "@/view/pages/partials/Detail/Equipment";
import Quotations from "@/view/pages/partials/Detail/Quotation";
import Invoices from "@/view/pages/partials/Detail/Invoice";
import Products from "@/view/pages/partials/Detail/Products";
import Warranty from "@/view/pages/partials/Detail/Warranty";
// import ListingTable from "@/view/pages/partials/Listing-Table.vue";
import { GET, PATCH } from "@/core/services/store/request.module";
import moment from "moment";
import VisitInternalAll from "@/view/pages/partials/Detail/VisitInternalAll.vue";
import Status from "@/view/pages/partials/Status.vue";

export default {
  mixins: [CommonMixin, ValidationMixin, PropertyMixin],
  name: "property-detail",
  title: "Site Location",
  data() {
    return {
      propertyTab: "property",
      property: 0,
      customer: 0,
      //propertyTab: null,
      pageLoading: true,
      historyLoading: true,
      deleteDialog: false,
      propertyArr: {},
      history: [],
      category: {
        property_id: 0,
        customer_id: 0,
        categoryList: [
          {
            name: null,
            subcategory: [
              {
                name: null,
              },
            ],
          },
        ],
      },

      tabs: [
        {
          title: "Overview",
          icon: "mdi-ticket",
          key: "property",
          disabled: false,
        },

        {
          title: "Visit",
          icon: "mdi-truck",
          key: "job",
          disabled: false,
        },
        {
          title: "Assets",
          icon: "mdi-tools",
          key: "equipment",
          disabled: false,
        },
        {
          title: "Site Location History",
          icon: "mdi-map-marker",
          key: "property-history",
          disabled: false,
        },
        /*{
          title: "Quotations",
          icon: "mdi-account-multiple",
          key: "quotation",
          disabled: false
        },
        {
          title: "Invoices",
          icon: "mdi-account-multiple",
          key: "invoice",
          disabled: false,
        },*/
        /*{
          title: "Products",
          icon: "mdi-credit-card",
          key: "product",
          disabled: false
        },
        {
          title: "Warranty",
          icon: "mdi-credit-card",
          key: "warranty",
          disabled: false
        },*/
        // {
        //   title: "Sub category",
        //   icon: "mdi-credit-card",
        //   key: "history",
        //   disabled: false,
        // },
      ],
      createTransactions: [
        {
          title: "Visit",
          action: "job",
        },
        /*{
          title: "Quotation",
          action: "quotation"
        },*/
        /* {
          title: "Invoice",
          action: "invoice",
        }, */
      ],
    };
  },
  components: {
    InternalHistoryDetail,
    Barcode,
    // ListingTable,
    DetailTemplate,
    CustomerPersonDialog,
    VisitInternalAll,
    Quotations,
    Products,
    Warranty,
    Invoices,
    Equipment,
    Status,
  },
  methods: {
    formatDateStartTime() {
      return moment().format("hh:mm A");
    },

    updateOrcreate() {
      const _this = this;
      _this.pageLoading = true;
      _this.category.customer_id = this.propertyArr.customer.id
        ? this.propertyArr.customer.id
        : 0;
      _this.category.property_id = this.propertyArr.id
        ? this.propertyArr.id
        : 0;
      _this.$store
        .dispatch(PATCH, { url: "property-category", data: _this.category })
        .then(() => {})
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    getCategories() {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(GET, { url: `property-category-list/${this.propertyArr.id}` })
        .then((row) => {
          this.category.categoryList = row.data;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    AddCatgory() {
      this.category.categoryList.push({
        name: null,
        subcategory: [
          {
            name: null,
          },
        ],
        /*    number: null, */
      });
    },
    AddSubCate(index) {
      this.category.categoryList[index].subcategory.push({
        name: null,
      });
    },
    deletecategory(index) {
      if (this.category.categoryList.length > 1) {
        this.category.categoryList.splice(index, 1);
      }
    },
    deleteSubcategory(index, Cindex) {
      if (this.category.categoryList[index].subcategory.length > 1) {
        this.category.categoryList[index].subcategory.splice(Cindex, 1);
      }
    },
    deleteProperty() {
      const _this = this;
      if (!_this.$refs.propertyDeleteForm.validate()) {
        return false;
      }
    },
    getHistories() {
      const _this = this;
      _this.$store
        .dispatch(GET, { url: `property/${_this.property}/history` })
        .then(({ data }) => {
          _this.history = data;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.historyLoading = false;
        });
    },
    routeToCustomer(id) {
      this.$router.push({
        name: "admin.customer.detail",
        params: { id },
      });
    },
  },
  mounted() {
    const _this = this;
    _this.checkTransactionPermission();
    _this.getHistories();
    _this.checkTabPermission();
    _this
      .getProperty()
      .then((response) => {
        _this.propertyArr = response;
        this.getCategories();
        _this.customer = response.customer
          ? _this.lodash.toSafeInteger(response.customer.id)
          : 0;
        _this.mapCenter = {
          lat: parseFloat(response.latitude),
          lng: parseFloat(response.longitude),
        };
        _this.$store.dispatch(SET_BREADCRUMB, [
          { title: "Site Location", route: "property" },
          { title: "Detail" },
          { title: response.barcode },
        ]);
      })
      .catch((error) => {
        _this.logError(error);
        _this.$router.go(-1);
      })
      .finally(() => {
        _this.pageLoading = false;
      });
  },
  created() {
    const _this = this;
    _this.property = _this.$route.params.id;
    if (!_this.property || _this.property <= 0) {
      _this.$router.go(-1);
    }

    if (_this.$route.query && _this.$route.query.tab) {
      _this.propertyTab = _this.$route.query.tab;
    }
  },
  computed: {
    getPageTitle() {
      let result = [];
      if (this.propertyArr && this.propertyArr.customer) {
        result.push(this.propertyArr.customer.display_name);
      }
      /*if(this.propertyArr && this.propertyArr.customer && this.propertyArr.customer.default_person){
        result.push(this.propertyArr.customer.default_person.display_name);
      }*/
      /* if (this.propertyArr && this.propertyArr.barcode) {
        result.push(this.propertyArr.barcode);
      } */
      return result.join(" • ");
    },
    // propertyTab: {
    //   set(val) {
    //     let query = { ...this.$route.query };
    //     query.tab = val;
    //     if (val != this.propertyTab) {
    //       this.$router.push({ query });
    //     }
    //   },
    //   get() {
    //     return this.$route.query.tab || "property";
    //   },
    // },
    countryName() {
      let result = "";
      if (this.lodash.isEmpty(this.propertyArr.country) === false) {
        result = this.propertyArr.country.name;
      }
      return result;
    },
    stateName() {
      let result = "";
      if (this.lodash.isEmpty(this.propertyArr.state) === false) {
        result = this.propertyArr.state.name;
      }
      return result;
    },
    cityName() {
      let result = "";
      if (this.lodash.isEmpty(this.propertyArr.city) === false) {
        result = this.propertyArr.city.name;
      }
      return result;
    },
    getStatus() {
      return this.lodash.isEmpty(this.propertyArr) === false
        ? this.propertyArr.activated
        : false;
    },
    getBarcode() {
      return this.lodash.isEmpty(this.propertyArr) === false
        ? this.propertyArr.barcode
        : false;
    },
  },
};
</script>
